import { Injectable } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { RespondConfirmation } from '../objects/DialogObject';
import { Observable } from 'rxjs';
import { MessagePopupComponent } from '../message-popup/message-popup.component';

@Injectable({
  providedIn: 'root'
})
export class MessagePopupService {

  bsModalRef: BsModalRef;

  constructor(
    private bsModalService: BsModalService,
    private respondConfirmation : RespondConfirmation
  ) { }


  popMessage(title: string, message: string, options: string[]): Observable<RespondConfirmation> {
    const initialState = {
      title: title,
      message: message,
      options: options,
      answer: ""
    };

    document.body.classList.add('modal-message');
    if (this.bsModalService.getModalsCount() > 0){
      document.querySelectorAll('.modal.fade').item(this.bsModalService.getModalsCount() - 1).classList.remove('show');
    }

    this.bsModalRef = this.bsModalService.show(MessagePopupComponent, { class: "modal-dialog-centered modal-message", ignoreBackdropClick: true, initialState });

    return new Observable<RespondConfirmation>(this.getConfirmSubscriber());
  }

  private getConfirmSubscriber() {
    return (observer) => {
      const subscription = this.bsModalService.onHidden.subscribe((reason: string) => {
        document.body.classList.remove('modal-message');
        if (document.querySelectorAll('.modal-backdrop').item(0)){
          document.querySelectorAll('.modal-backdrop').item(0).classList.remove('layer');
        }
        if (this.bsModalService.getModalsCount() > 0){
          document.querySelectorAll('.modal.fade').item(this.bsModalService.getModalsCount() - 1).classList.add('show');
        }

        this.respondConfirmation.answer = this.bsModalRef.content.answer;
        observer.next(this.respondConfirmation);
        observer.complete();
      });

      return {
        unsubscribe() {
          subscription.unsubscribe();
        }
      };
    }
  }
}
